// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"484b8427","455":"0314ea2e","977":"b7115409"}[chunkId] + ".chunk.js";
};